export default (fn: () => void): ReturnType<typeof setTimeout> =>
  setTimeout(fn, 1);
